<template>
  <div class="product" id="product">
    <v-app>
      <v-app-bar
      app
      color='primary'
      dark
      height="564"
      absolute
      >
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :pc='pc' :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor"></FirstNavbar>
          <!-- 大标题 -->
          <div class='first_title_box' style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col  cols="12">
                <h1 class="first_title white--text">
                  软件服务
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_product.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <v-app-bar
          :fixed='second_bar_fixed'
          prominent
          height="64"
          color="white"
          :flat='!second_bar_fixed'
        >
          <v-tabs v-model="second_active_tab" centered>
            <v-tab v-for="tab in contentList" :key='tab.index'  @click="goTo(tab.index)" class="body_text">{{tab.firstTitle}}</v-tab>
          </v-tabs>
        </v-app-bar>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <!-- 服务优势 -->
              <BoxTitle :firstTitle="contentList[0].firstTitle" :desc="contentList[0].desc" :index="contentList[0].index"></BoxTitle>
              <BoxSpaceAround :data='contentList[0].children[0]' :dark="false" :img_top="true" img_size='90px' card_width="250px" card_height="16rem"></BoxSpaceAround>
              <!-- 智慧政务 -->
              <BoxTitle :firstTitle="contentList[1].firstTitle" :desc="contentList[1].desc" :dark="true" :index="contentList[1].index"></BoxTitle>
              <BoxLr :data='contentList[1].children[0]' :left_img="true" :dark="true"></BoxLr>
              <BoxLr :data='contentList[1].children[1]' :left_img="false" :dark="true"></BoxLr>
              <BoxLr :data='contentList[1].children[2]' :left_img="true" :dark="true"></BoxLr>
              <BoxSpaceAround :data='contentList[1].children[3]' :img_top="true" img_size='250px' card_width="260px" card_height="20rem" :dark="true"></BoxSpaceAround>
              <!-- 智慧教育 -->
              <BoxTitle :firstTitle="contentList[2].firstTitle" :desc="contentList[2].desc" :index="contentList[2].index"></BoxTitle>
              <BoxLr :data='contentList[2].children[0]' :left_img="false"></BoxLr>
              <BoxLr :data='contentList[2].children[1]' :left_img="true"></BoxLr>
              <BoxSpaceAround :data='contentList[2].children[2]' :dark="false" :img_top="true" img_size='250px' card_width="260px" card_height="20rem"></BoxSpaceAround>
              <!-- 企业办公 -->
              <BoxTitle :firstTitle="contentList[3].firstTitle" :desc="contentList[3].desc" :dark="true" :index="contentList[3].index"></BoxTitle>
              <BoxLr :data='contentList[3].children[0]' :left_img="false" :dark="true"></BoxLr>
              <BoxLr :data='contentList[3].children[1]' :left_img="true" :dark="true"></BoxLr>
              <BoxSpaceAround :data='contentList[3].children[2]' :dark="true" :img_top="true" img_size='250px' card_width="260px" card_height="20rem"></BoxSpaceAround>
              <!-- 规划咨询 -->
              <BoxTitle :firstTitle="contentList[4].firstTitle" :desc="contentList[4].desc" :index="contentList[4].index"></BoxTitle>
              <BoxLr :data='contentList[4].children[0]' :dark="false" :left_img="false"></BoxLr>
              <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn
                  v-show="!floatHidden"
                  color="primary"
                  fixed
                  bottom
                  right
                  fab
                  @click="goTo(0)"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import BoxLr from '../components/box-lr.vue'
import BoxTitle from '../components/box-title.vue'
import BoxSpaceAround from '../components/box-space-around.vue'

export default {
  name: 'products',

  components: {
    FootContent,
    FirstNavbar,
    BoxLr,
    BoxSpaceAround,
    BoxTitle
  },

  data: () => ({
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 3,
    // 二级导航选项卡
    second_active_tab: 0,
    // 二级导航是否冻结
    second_bar_fixed: false,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 内容列表
    contentList: [{
      index: 1,
      firstTitle: '服务优势',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: 'fwys1.png',
            title: '可定制解决方案',
            subtitle: '',
            body: '针对个性化设置的需要，可提供定制化解决方案'
          }, {
            index: 2,
            src: 'fwys2.png',
            title: '数据托管',
            subtitle: '',
            body: '可托管至嘉旭福美数据中心，低成本，安全可靠'
          }, {
            index: 3,
            src: 'fwys3.png',
            title: '数据私有',
            subtitle: '',
            body: '平台由机构独立运营，用户数据由机构私有'
          }, {
            index: 4,
            src: 'fwys4.png',
            title: '免费运维',
            subtitle: '',
            body: '一年内免费维护，7*24小时快速响应'
          }]
        }
      }]
    }, {
      index: 2,
      firstTitle: '智慧政务',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '软件服务智慧政务1.png',
        content: {
          title: '',
          btn: '',
          body: '督查工作信息化管理平台、重点工作管理平台、工作流转平台、智慧政协、公文流转平台等平台结合政府工作特点，帮助政府实现工作任务下发、协作处理、问题反馈、结果汇报、进展查看、督查督办、公文流转的一体化工作流程，帮助打造透明、高效政府',
          list: []
        }
      }, {
        index: 2,
        src: '软件服务智慧政务2.png',
        content: {
          title: '传统政务办公的痛点',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '重复工作、人工汇总、人工汇报、人工催办，效率低，浪费人力',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 2,
            title: '纸质传递、存档，易丢失',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 3,
            title: '协作沟通、文件审批沟通难，步骤多',
            subtitle: '',
            body: '',
            src: ''
          }]
        }
      }, {
        index: 3,
        src: '软件服务智慧政务3.png',
        content: {
          title: '产品优势',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '无纸化办公，更高效，易存档',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 2,
            title: '在线协作办公，文件在线审批，工作更顺畅',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 3,
            title: '到期自动预警，无需人工催办',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 4,
            title: '数据可视化展示，工作成果易记、易看、易懂、易比，助力领导科学化决策',
            subtitle: '',
            body: '',
            src: ''
          }]
        }
      }, {
        index: 4,
        src: '',
        content: {
          title: '产品案例',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '督查工作信息化管理平台',
            subtitle: '',
            body: '',
            src: '政务.png'
          }, {
            index: 2,
            title: '福美工作流转平台',
            subtitle: '',
            body: '',
            src: '政务2.png'
          }, {
            index: 3,
            title: '公文管理系统',
            subtitle: '',
            body: '',
            src: '政务3.png'
          }, {
            index: 4,
            title: '重点工作管理平台',
            subtitle: '',
            body: '',
            src: '政务4.png'
          }]
        }
      }]
    }, {
      index: 3,
      firstTitle: '智慧教育',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '软件服务智慧教育1.jpg',
        content: {
          title: '',
          btn: '',
          body: '在线教育平台、数字校园等平台，帮助学校实现线上教学，提高了学校管理、教学和服务水平',
          list: []
        }
      }, {
        index: 2,
        src: '软件服务智慧教育2.jpg',
        content: {
          title: '产品优势',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '为教育局、学校提供一站式解决方案',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 2,
            title: '在线作业发布、提交，解决在线教育课后辅导问题',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 3,
            title: '教师考核、学生情况可视化数据统计，直观了解教学管理中各项问题',
            subtitle: '',
            body: '',
            src: ''
          }]
        }
      }, {
        index: 3,
        src: '',
        content: {
          title: '产品案例',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '福美教育管理信息系统',
            subtitle: '',
            body: '',
            src: '在线教育5.png'
          }, {
            index: 2,
            title: '数字校园平台',
            subtitle: '',
            body: '',
            src: '教育2.png'
          }, {
            index: 3,
            title: '福美远程教育平台',
            subtitle: '',
            body: '',
            src: '在线教育6.png'
          }, {
            index: 4,
            title: '福美在线教育平台',
            subtitle: '',
            body: '',
            src: '教育4.png'
          }]
        }
      }]
    }, {
      index: 4,
      firstTitle: '企业办公',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '软件服务企业办公1.jpg',
        content: {
          title: '',
          btn: '',
          body: '福美综合管理平台包含人事管理、办公管理、即时通讯、资产管理、运维管理、进销存系统，助力企业实现日常办公及运营管理的标准化和高效化',
          list: []
        }
      }, {
        index: 2,
        src: '软件服务企业办公.jpg',
        content: {
          title: '产品优势',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '涵盖企业日常管理全方面工作，日常办公更高效',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 2,
            title: '数据看板直观展示企业各项运营情况，助力企业科学化管理',
            subtitle: '',
            body: '',
            src: ''
          }, {
            index: 3,
            title: '统一身份认证，使用更方便',
            subtitle: '',
            body: '',
            src: ''
          }]
        }
      }, {
        index: 3,
        src: 'products2.jpg',
        content: {
          title: '产品案例',
          body: '',
          btn: '',
          list: [{
            index: 1,
            title: '福美ERP看板',
            subtitle: '',
            body: '',
            src: '企业.png'
          }, {
            index: 2,
            title: '福美综合办公平台',
            subtitle: '',
            body: '',
            src: '企业2.png'
          }, {
            index: 3,
            title: '福美资产管理系统',
            subtitle: '',
            body: '',
            src: '企业3.png'
          }, {
            index: 4,
            title: '福美进销存平台',
            subtitle: '',
            body: '',
            src: '企业4.png'
          }]
        }
      }]
    }, {
      index: 5,
      firstTitle: '规划咨询',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '软件服务规划咨询.png',
        content: {
          title: '',
          btn: '',
          body: '运用先进的管理理念和信息技术，从经济发展和产业支撑着手，有针对性的进行信息化管理，提出可行性的规划设计方案，以提升客户信息化应用水平，促进经济循环发展和产业能力提升',
          list: []
        }
      }]

    }]
  }),

  created () {
    this.$nextTick(() => {
      this.toPart()
    })
  },
  mounted () {
    this.goTo(0)
    // // 鼠标滚动事件监听
    window.addEventListener('scroll', this.handleScroll)
    this.contentList.forEach((val, index, arry) => {
      this.contentList[index].scrollTop = this.$el.querySelector('#part' + this.contentList[index].index).offsetTop + 564
    })
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },

  methods: {
    // 定位
    toPart () {
      // 查找存储的锚点id
      const Id = localStorage.getItem('toPart')
      const toElement = document.getElementById(Id)
      // 锚点存在跳转
      if (Id) {
        toElement.scrollIntoView()
      }
    },
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
        } else {
          if (width > 992 && width <= 1100) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
          } else {
            if (width > 1200 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
              }
            }
          }
        }
      }
    },
    //  鼠标滚动事件（导航栏是否透明、导航栏是否隐藏投影、导航选项卡切换，悬浮按钮是否出现）
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.second_bar_fixed = true
        this.gotop = true
      } else {
        this.second_bar_fixed = false
        this.barColor = 'rgba(63, 81, 181,0)'
        this.gotop = false
      }
      if (scrollTop < this.contentList[0].scrollTop) {
        this.second_active_tab = 0
        this.floatHidden = false
      } else if (scrollTop > this.contentList[this.contentList.length - 1].scrollTop) {
        this.second_active_tab = this.contentList.length - 1
        this.floatHidden = false
      } else {
        for (var i = 1; i < this.contentList.length; i++) {
          if (i <= this.contentList.length) {
            if (scrollTop >= this.contentList[i - 1].scrollTop & scrollTop < this.contentList[i].scrollTop) {
              this.second_active_tab = i - 1
              this.floatHidden = false
            }
          }
        }
      }
    },
    goTo (index) {
      // console.log(this.secondTabs, ele)
      // var anchor = this.$el.querySelector(ele)
      // document.documentElement.scrollTop = anchor.offsetTop + 500
      if (index === 0) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      } else {
        document.body.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
        document.documentElement.scrollTop = document.documentElement.querySelector('#part' + this.contentList[index - 1].index).offsetTop + 564
      }
    }
  },

  // 将存储的锚点置空，否则会影响其他页面跳转到当前页面
  destroyed () {
    localStorage.setItem('toPart', '')
  }

}
</script>

<style>

</style>
